import C from './component'
export { PureSelect } from './pure_component'

export default C